module.exports = __webpack_public_path__ + "static/img/12.d67640a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsCenteru/12.png
// module id = m5YV
// module chunks = 1